import React from 'react';
import { Link } from 'react-router-dom';

const heroStats = [
  {
    value: '16+',
    label: 'Corporate Clients',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M17 20v-1a4 4 0 00-4-4H7a4 4 0 00-4 4v1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="10" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M23 20v-1a3.5 3.5 0 00-2.5-3.35M16 4.15a3.5 3.5 0 010 6.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    value: '8+',
    label: 'Product Lines',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 22V12M12 12L3 7l9-5 9 5-9 5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M3 7v10l9 5 9-5V7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    value: '100%',
    label: 'Custom Built',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M9.5 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    value: 'Noida',
    label: 'NCR Base',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 21s6-5.2 6-10a6 6 0 10-12 0c0 4.8 6 10 6 10z" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="11" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
];

const heroServices = [
  {
    name: 'Site Office / Farm House',
    image: '/products/projects/image1.jpeg',
  },
  {
    name: 'Servant Room',
    image: '/products/projects/image2.jpeg',
  },
  {
    name: 'Site Office',
    image: '/products/projects/image3.jpeg',
  },
  {
    name: 'Cafeteria On Roof',
    image: '/products/projects/image4.jpeg',
  },
  {
    name: 'Puff Panel Guard Cabin',
    image: '/products/projects/image5.jpeg',
  },
  {
    name: 'ATM Kiosk',
    image: '/products/projects/image6.jpeg',
  },
  {
    name: 'Guard Cabin',
    image: '/products/projects/image7.jpeg',
  },
  {
    name: 'Reception Entry Gate',
    image: '/products/projects/image8.jpeg',
  },
];

const features = [
  {
    icon: '🏗️',
    title: 'Custom Porta Cabins',
    description:
      'Tailored porta cabins, guard cabins, and site offices for construction sites and remote locations.',
  },
  {
    icon: '⚡',
    title: 'Rapid Deployment',
    description:
      'Prefabricated off-site construction means faster setup without compromising structural quality.',
  },
  {
    icon: '🛡️',
    title: 'Built to Last',
    description:
      'Cement board, ACP sheet, puff panel, and MS structures engineered for durability and cost efficiency.',
  },
  {
    icon: '🔧',
    title: 'End-to-End Service',
    description:
      'From design and fabrication to installation — false ceilings, partitions, shades, and interior work.',
  },
];

function Home() {
  return (
    <div className="home">
      <section className="hero-mockup">
        <div className="hero-mockup-grid">
          <div className="hero-mockup-left">
            <div className="hero-location">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 21s6-5.2 6-10a6 6 0 10-12 0c0 4.8 6 10 6 10z" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="11" r="2.5" stroke="currentColor" strokeWidth="2" />
              </svg>
              Noida, India
            </div>

            <h1 className="hero-mockup-title">
              Modern Prefab
              <span className="hero-mockup-title-gold">Structures</span>
              for Every Site
            </h1>

            <p className="hero-mockup-desc">
              Customizable porta cabins, site offices, false ceilings, and complete prefab systems —
              built to your specifications.
            </p>

            <div className="hero-mockup-actions">
              <Link to="/contact" className="btn btn-gold">
                Get a Quote
                <span aria-hidden="true">→</span>
              </Link>
              <Link to="/productservices" className="btn btn-outline-white">
                View Products
                <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>

          <div className="hero-mockup-right">
            <img
              src="/products/projects/hero-highlight.jpeg"
              alt="Adhunik Prefab site office and farm house cottage"
              className="hero-mockup-bg"
            />

            <div className="hero-mockup-panel">
              <h2 className="hero-overlay-title">Adhunik Prefab Systems</h2>
              <p>
                provides you the best range of False Ceilings, Guard Porta Cabins, ACP Work
                Services, Site Offices, Gypsum Ceiling Work, Farm House.
              </p>
            </div>

            <div className="hero-services">
              <div className="hero-services-thumbs">
                {heroServices.map((service) => (
                  <div key={service.name} className="hero-service-thumb">
                    <img src={service.image} alt={service.name} />
                    <span className="hero-service-name">{service.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="hero-mockup-stats">
          {heroStats.map((stat) => (
            <div key={stat.label} className="hero-mockup-stat">
              <div className="hero-mockup-stat-icon">{stat.icon}</div>
              <div className="hero-mockup-stat-text">
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="page home-sections">
        <section className="intro-band">
          <div>
            <p className="page-eyebrow">Who We Are</p>
            <h2 className="section-title section-title--left">Pioneers in Off-Site Construction</h2>
            <p>
              Adhunik Prefab Systems are the leading manufacturers of high-quality customizable porta
              cabins designed to meet your specific needs. From construction sites to remote locations,
              we deliver durable and cost-effective solutions for temporary and permanent requirements.
            </p>
            <p>
              We bridge the gap between traditional craftsmanship and contemporary speed — specializing
              in design, fabrication, and installation for industrial and commercial sectors.
            </p>
            <Link to="/about" className="btn btn-primary">
              Learn More About Us
            </Link>
          </div>
          <div className="intro-image">
            <img src="/ourteams.png" alt="Adhunik Prefab Systems team" />
          </div>
        </section>

        <section className="section">
          <p className="page-eyebrow page-eyebrow--center">Why Choose Us</p>
          <h2 className="section-title">Built for Speed, Strength &amp; Scale</h2>
          <div className="card-grid">
            {features.map((feature) => (
              <div key={feature.title} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-band">
          <h2>Ready to Transform Your Space?</h2>
          <p>
            Tell us about your project — porta cabins, site offices, false ceilings, or full prefab
            structures. We&apos;ll respond with a tailored solution.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Contact Us Today
          </Link>
        </section>
      </div>
    </div>
  );
}

export default Home;
